module.exports = __webpack_public_path__ + "static/media/service_system_3.348b7dcf.png";